import { useQuery } from '@tanstack/react-query';
import { fetchApi } from '../api/fetch';

interface OnboardingProgress {
  completed: number;
  total: number;
  done: boolean;
}

export function useOnboardingProgress() {
  return useQuery<OnboardingProgress>({
    queryKey: ['onboarding-progress'],
    queryFn: () => fetchApi('/onboarding/progress'),
    staleTime: 30_000,
    retry: false,
  });
}
